module.exports = __webpack_public_path__ + "img/ind_phone2.5fcad5e8.png";